import { toast, ToastOptions } from 'react-toastify';

export const bookmarkThemeOptions = (
  theme: 'light' | 'dark'
): ToastOptions => ({
  position: toast.POSITION.BOTTOM_CENTER,
  theme: theme,
  closeButton: false,
  hideProgressBar: true,
  pauseOnHover: true,
  autoClose: 2000,
});
